import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import ar from "./ar";

export const LANGUAGE_STORAGE_KEY = "abos_ui_language";
export const readLanguage = () => {
  try {
    return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) === "ar" ? "ar" : "en";
  } catch {
    return "en";
  }
};

const applyDocumentLanguage = (language) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = language === "ar" ? "ar" : "en";
  document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
};

const initialLanguage = readLanguage();
applyDocumentLanguage(initialLanguage);

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  initImmediate: false,
});

i18n.on("languageChanged", (language) => {
  applyDocumentLanguage(language);
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language === "ar" ? "ar" : "en");
  } catch {
    // Browser storage can be unavailable without blocking the language switch.
  }
});

export default i18n;
